/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./sidenav-info.component";
var styles_CuiSidenavInfoComponent = ["[_nghost-%COMP%] { display: block; }"];
var RenderType_CuiSidenavInfoComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_CuiSidenavInfoComponent, data: {} });
export { RenderType_CuiSidenavInfoComponent as RenderType_CuiSidenavInfoComponent };
export function View_CuiSidenavInfoComponent_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_CuiSidenavInfoComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "cui-sidenav-info", [], null, null, null, View_CuiSidenavInfoComponent_0, RenderType_CuiSidenavInfoComponent)), i0.ɵdid(1, 49152, null, 0, i1.CuiSidenavInfoComponent, [], null, null)], null, null); }
var CuiSidenavInfoComponentNgFactory = i0.ɵccf("cui-sidenav-info", i1.CuiSidenavInfoComponent, View_CuiSidenavInfoComponent_Host_0, {}, {}, ["*"]);
export { CuiSidenavInfoComponentNgFactory as CuiSidenavInfoComponentNgFactory };



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/navigation/sidenav/sidenav-info/sidenav-info.component.ngfactory.js.pre-build-optimizer.js